import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import { Button, Row, Col, Label, Input, InputGroup, FormFeedback, InputGroupAddon, InputGroupText } from 'reactstrap';
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../../api";

class Modal extends Component {
     constructor(props) {
          super(props);
          this.state = {
               id: null,
               username: '',
               password: '',
               Habilitado: false,
               Telefono: '',
               codSIGE: '',
               codSIGEPuntoVenta: '',
               Nombre: '',
               postVariables: ['username',
                    'password', 'Habilitado',
                    'Telefono', 'codSIGE',
                    'codSIGEPuntoVenta',
               ],
               errors: []
          };
     }

     static propTypes = {
          onSubmit: PropTypes.func,
          id: PropTypes.func,
          action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE', 'LOCK', 'UNLOCK', 'FORCE_UPDATE']).isRequired,
     }

     resetForm() {
          this.setState({
               id: null,
               username: '',
               password: '',
               Habilitado: false,
               Telefono: '',
               codSIGE: '',
               codSIGEPuntoVenta: '',
               errors: [],
          });
     }

     getData() {
          const { action } = this.props;
          const { postVariables } = this.state;
          if (action == "LOCK") {
               return {
                    'Habilitado': false,
               };
          } if (action == "UNLOCK") {
               return {
                    'Habilitado': true,
               };
          } else {
               let data = {};
               postVariables.forEach(x => data[x] = this.state[x]);
               return data;
          }
     }

     setData(data) {
          if (data.success) {
               this.setState({
                    username: data.username ? data.username.split('@')[0] : '',
                    password: data.password,
                    Habilitado: data.Habilitado,
                    Telefono: data.Telefono,
                    codSIGEPuntoVenta: data.puntoDeVenta ? data.puntoDeVenta.Codigo : '',
                    id: data.id,
                    Nombre: data.Nombre,
                    Email: data.Email,
                    Telefono: data.Telefono,
                    Codigo: data.Codigo
               })
          }
     }

     setErrors(errors) {
          this.setState({
               errors: errors,
          });
     }

     onChangeField(field, value) {
          this.setState(prevState => {
               let errors = prevState.errors;
               if (errors) errors[field] = null;
               prevState.errors = errors;
               prevState[field] = value;
               return prevState;
          });
     }

     getError(field) {
          let errors = this.state.errors;
          if (errors) return errors[field];
          else return null;
     }

     modalVars() {
          const { action } = this.props;
          if (action == "CREATE") {
               return {
                    get: false,
                    submitType: "POST",
                    title: "Nuevo Vendedor",
                    buttonTitle: "Nuevo",
                    danger: false,
                    buttonIcon: "fa fa-plus fa-lg",
                    successMessage: "El Vendedor ha sido creado con éxito.",
                    saveButton: true,
                    saveButtonLabel: "Guardar",
                    buttonClass: "",
                    disabled: false,
               };
          } else if (action == "EDIT") {
               return {
                    get: true,
                    submitType: "PATCH",
                    title: "Alta de Cuenta para SIGE PEDIDOS",
                    buttonTitle: "Alta Cuenta Vendedor",
                    danger: false,
                    buttonIcon: "fa fa-level-up fa-lg",
                    successMessage: "La Cuenta para el Vendedor ha sido dado de alta con éxito.",
                    saveButton: true,
                    saveButtonLabel: "Guardar",
                    buttonClass: "",
                    disabled: false,
                    id: this.props.id,
               };
          } else if (action == "DETAIL") {
               return {
                    get: true,
                    submitType: null,
                    title: "Vendedor",
                    buttonTitle: "Ver",
                    danger: false,
                    buttonIcon: "fa fa-search fa-lg",
                    successMessage: "",
                    saveButton: false,
                    buttonClass: "",
                    disabled: true,
                    id: this.props.id,
               };
          } else if (action == "DELETE") {
               return {
                    get: true,
                    submitType: "DELETE",
                    title: "Eliminar Cuenta de Vendedor",
                    buttonTitle: "Eliminar",
                    danger: true,
                    buttonIcon: "fa fa-trash fa-lg",
                    successMessage: "La Cuenta del Vendedor ha sido eliminado con éxito.",
                    saveButton: true,
                    saveButtonLabel: "Eliminar",
                    buttonClass: "btn-danger",
                    disabled: true,
                    id: this.props.id,
               };
          } else if (action == "LOCK") {
               return {
                    get: true,
                    submitType: "PATCH",
                    title: "Deshabilitar Cuenta de Vendedor",
                    buttonTitle: "Deshabilitar Cuenta",
                    danger: false,
                    warning: true,
                    buttonIcon: "fa fa-lock fa-lg",
                    successMessage: "La Cuenta del Vendedor ha sido deshabilitada con éxito.",
                    saveButton: true,
                    saveButtonLabel: "Deshabilitar",
                    buttonClass: "btn-warning",
                    disabled: true,
                    id: this.props.id,
               };
          } else if (action == "UNLOCK") {
               return {
                    get: true,
                    submitType: "PATCH",
                    title: "Habilitar Cuenta de Vendedor",
                    buttonTitle: "Habilitar",
                    danger: false,
                    warning: true,
                    buttonIcon: "fa fa-unlock fa-lg",
                    successMessage: "La Cuenta del Vendedor ha sido habilitada con éxito.",
                    saveButton: true,
                    saveButtonLabel: "Habilitar",
                    buttonClass: "btn-warning",
                    disabled: true,
                    id: this.props.id,
               };
          } else if (action == "FORCE_UPDATE") {
               return {
                    get: true,
                    submitType: "POST",
                    title: "Forzar Actualización",
                    buttonTitle: "Forzar Actualización",
                    danger: false,
                    warning: true,
                    buttonIcon: "fa fa-refresh fa-lg",
                    successMessage: "El dispositivo del Vendedor ha sido actualizado.",
                    saveButton: true,
                    saveButtonLabel: "Actualizar",
                    buttonClass: "btn-success",
                    disabled: true,
                    id: this.props.id,
               };
          }
     }

     render() {
          let vars = this.modalVars();
          const { Email, Codigo, Telefono, username,
               password, Habilitado, codSIGEPuntoVenta } = this.state;

          let submitUrl = null;
          if (vars.submitType) {
               submitUrl = this.props.action == "FORCE_UPDATE" ?
                    api.gestion.ventas.vendedores.vendedorForceUpdate :
                    api.gestion.ventas.vendedores.vendedores;
          }

          return (
               <ParadigmaModal
                    getUrl={(vars.get ? api.gestion.ventas.vendedores.vendedores : null)}
                    submitUrl={submitUrl}
                    submitType={vars.submitType}
                    id={vars.id}
                    onGotData={(data) => this.setData(data)}
                    onGotErrors={(errors) => this.setErrors(errors)}
                    onSubmit={(e) => this.props.onSubmit(e)}
                    onClose={() => this.resetForm()}
                    onPreSubmit={() => this.getData()}

                    title={vars.title}

                    danger={vars.danger}
                    buttonClass={vars.buttonClass}

                    successMessage={vars.successMessage}
                    missingIdMessage={"Debe seleccionar una fila."}
                    saveButtonLabel={vars.saveButtonLabel}
                    buttonTitle={vars.buttonTitle}
                    buttonIcon={vars.buttonIcon}
                    saveButton={vars.saveButton}
                    closeButton={true}
               >
                    <ParadigmaLabeledInput
                         disabled={true}
                         clearable={false}
                         md={[3, 9]}
                         label={"Vendedor"}
                         value={this.state.Nombre}
                    />
                    <ParadigmaLabeledInput
                         disabled={true}
                         md={[3, 9]}
                         maxLength={256}
                         label={"Email"}
                         value={Email && Email != '' ? Email : "N/A"}
                    />
                    <ParadigmaLabeledInput
                         disabled={true}
                         md={[3, 9]}
                         maxLength={128}
                         label={"Telefono"}
                         value={Telefono && Telefono != '' ? Telefono : "N/A"}
                    />
                    <ParadigmaLabeledInput
                         disabled={true}
                         md={[3, 3]}
                         mxLaength={4}
                         label={"Codigo SIGE"}
                         value={Codigo}
                    />
                    <ParadigmaLabeledInput
                         disabled={vars.disabled}
                         md={[3, 3]}
                         classNames={["text-nowrap",""]}
                         maxLength={4}
                         label={"Punto de Venta"}
                         value={codSIGEPuntoVenta}
                         onChange={(e) => this.onChangeField('codSIGEPuntoVenta', e.target.value)}
                         error={() => this.getError('codSIGEPuntoVenta')}
                    />
                    <ParadigmaLabeledInput
                         disabled={vars.disabled}
                         md={[3, 9]}
                         maxLength={128}
                         label={"Username"}
                         value={username}
                         error={() => this.getError('username')}
                         inputComponent={
                              <InputGroup>
                                   <Input
                                        className="w-50"
                                        value={this.state.username}
                                        disabled={vars.disabled}
                                        onChange={(e) => {
                                             let errors = this.state.errors;
                                             if (errors) errors.username = null;
                                             this.setState({ username: e.target.value, errors: errors });
                                        }}
                                   />
                                   <InputGroupAddon addonType="append">
                                        <InputGroupText style={{height:"35px", borderRadius: 0}}>{"@" + localStorage.getItem('driver_gestion')}</InputGroupText>
                                   </InputGroupAddon>
                              </InputGroup>
                         }
                    />
                    <ParadigmaLabeledInput
                         disabled={vars.disabled}
                         md={[3, 9]}
                         maxLength={128}
                         label={"Password"}
                         value={password}
                         onChange={(e) => this.onChangeField('password', e.target.value)}
                         error={() => this.getError('password')}
                    />
                    <ParadigmaLabeledInput
                         md={[3, 9]}
                         label={"Habilitado"}
                         inputComponent={
                              <div className="d-flex">
                                   <Button
                                        disabled={vars.disabled}
                                        className="mr-1 flex-grow-1"
                                        color={Habilitado == true ? 'success' : 'secondary'}
                                        onClick={() => this.onChangeField('Habilitado', true)}
                                   >
                                        SI
                                   </Button>
                                   <Button
                                        disabled={vars.disabled}
                                        className="mr-1 flex-grow-1"
                                        color={Habilitado == false ? 'danger' : 'secondary'}
                                        onClick={() => this.onChangeField('Habilitado', false)}
                                   >
                                        NO
                                   </Button>
                              </div>
                         }
                    />
               </ParadigmaModal>
          );
     }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Vendedores/Modal.js